import React from 'react';
import { cartMoney } from './cartMoney';
import { shopWords } from './shopWords';
import { useAutomaticDiscount } from '../components/useAutomaticDiscount';
import { useDiscountOffers } from '../components/useDiscountOffers';
import { isThemePreview } from '../api/previewVisit';
import type { Commerce } from './ShopCommerce';

// What the cart comes to so far, as the drawer and the cart page both show it: the store's automatic discount on
// these lines under its title, when one applies, then the estimated total after it. Delivery is settled at checkout.
export const CartEstimate: React.FC<{ commerce: Commerce }> = ({ commerce }) => {
  const { quote, currency, direction, language } = commerce;
  const offers = useDiscountOffers(!isThemePreview());
  const cart = quote ? { lineItems: quote.lines.map((l) => ({ productId: l.productId, quantity: l.quantity, lineTotal: Number(l.totalPrice) })), subtotal: quote.subtotal, shippingFee: 0 } : null;
  const saving = useAutomaticDiscount(cart, offers.automatic);
  const off = saving && saving.totalDiscount > 0 ? saving.totalDiscount : 0;
  return (
    <>
      {off > 0 && saving && (
        <p className="xe-cart-saving"><span dir="auto">{saving.title}</span><span>−{cartMoney(off, currency, direction)}</span></p>
      )}
      <p className="xe-cart-total" aria-busy={commerce.loading}>
        <span>{shopWords(language).estimatedTotal}</span>
        {quote ? <strong>{cartMoney(Math.max(0, quote.subtotal - off), currency, direction)}</strong> : <span className="xe-cart-skel xe-cart-skel--total" />}
      </p>
    </>
  );
};
